import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchLeadConfigs = createAsyncThunk("fetchLeadConfigs", async ({ filters }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		module_name: filters?.module_name ?? "",
		identifier: filters?.identifier ?? "",
		sub_identifier: filters?.sub_identifier ?? "",
	});

	const response = await axiosHttp.get(`configuration/details?${params}`, config);
	return response.data.data;
});

const LeadProjectConfigurationSlice = createSlice({
	name: "LeadProjectConfigurationSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchLeadConfigs.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchLeadConfigs.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchLeadConfigs.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default LeadProjectConfigurationSlice.reducer;
